export function useWebWorker(workerPath) {
  const worker = ref(null);
  const result = ref(null);

  onMounted(() => {
    if (window.Worker) {
      worker.value = new Worker(workerPath);

      worker.value.onmessage = (event) => {
        result.value = event.data;
      };
    }
  });

  function sendMessage(data) {
    worker.value?.postMessage(data);
  }

  onBeforeUnmount(() => {
    worker.value?.terminate();
    worker.value = null;
  });

  return { worker, result, sendMessage };
}